import { httpClient } from '@alfa-bank/site-http-client';
import { AUTH_OTP_VERIFY } from '@alfa-bank/site-envconfig';

import type { TVerifyPhoneCodeProps, TVerifyPhoneCodeResponse } from '../models';

/**
 * Для авторизации клиент должен подтвердить свой номер телефона.
 * Необходимо проверить:
 *  - код подтверждения, который ввел пользователь,
 *  - возможность продолжения работы над заявками в gateway.
 * {@link - https://confluence.moscow.alfaintra.net/pages/viewpage.action?pageId=1927163608 - аналитика}
 */
export const verifyPhoneCode = ({ phone, prodType, signCode }: TVerifyPhoneCodeProps) =>
    httpClient.post<TVerifyPhoneCodeResponse>(AUTH_OTP_VERIFY(), {
        phone,
        prodType,
        signCode,
    });
